/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
// import { Store } from 'vuex'
import store from "@/store/store.js";
import constants from "@/constants";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/",
          redirect: "/about"
        },
        {
          path: "/gala",
          redirect: "/gala/about"
        },
        {
          path: "/oauth-callback",
          name: "oauth-callback",
          component: () => import("@/views/auth/OauthCallback.vue"),
        },

        {
          path: "/login/board/invite/:invitePhrase",
          name: "board-invite-auto-login",
          component: () => import("@/views/auth/LoginLink.vue"),
        },

        {
          path: "/login/magic/:invitePhrase",
          name: "magic-link-auto-login",
          component: () => import("@/views/auth/MagicLink.vue"),
        },
        // {
        //   path: "/error-404",
        //   name: "page-error-404",
        //   component: () => import("@/views/pages/Error404.vue"),
        // },
      ],
    },
    {
      // =============================================================================
      // EDITOR LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Editor.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/:boardSlug/:boardUserId/editor/preview",
          name: "editor-preview-custom",
          component: () => import("./views/editor/Main.vue"),
          meta: {
            rule: "editor",
            title: "Preview | Editor | GetBoarded",
          },
        },
        {
          path: "/preview",
          name: "editor-preview",
          component: () => import("./views/editor/Main.vue"),
          meta: {
            rule: "editor",
            title: "Preview | Editor | GetBoarded",
          },
        },
        {
          path: "/:organizationSlug/preview",
          name: "editor-preview-org",
          component: () => import("./views/editor/Main.vue"),
          meta: {
            rule: "editor",
            title: "Preview | Editor | GetBoarded",
          },
        },
        {
          path: "/:boardSlug/:boardUserId/about",
          name: "editor-about-custom",
          component: () => import("./views/editor/About.vue"),
          meta: {
            rule: "editor",
            title: "About | Editor | GetBoarded",
          },
        },
        {
          path: "/about",
          name: "editor-about",
          component: () => import("./views/editor/About.vue"),
          meta: {
            rule: "editor",
            title: "About | Editor | GetBoarded",
          },
        },
        {
          path: "/:organizationSlug/about",
          name: "editor-about-org",
          component: () => import("./views/editor/About.vue"),
          meta: {
            rule: "editor",
            title: "About | Editor | GetBoarded",
          },
        },
        {
          path: "/:boardSlug/:boardUserId/contact",
          name: "editor-contact-custom",
          component: () => import("./views/editor/Contact.vue"),
          meta: {
            rule: "editor",
            title: "Contact | Editor | GetBoarded",
          },
        },
        {
          path: "/contact",
          name: "editor-contact",
          component: () => import("./views/editor/Contact.vue"),
          meta: {
            rule: "editor",
            title: "Contact | Editor | GetBoarded",
          },
        },
        {
          path: "/contact-v2",
          name: "editor-contact",
          component: () => import("./views/editor/ContactV2.vue"),
          meta: {
            rule: "editor",
            title: "Contact | Editor | GetBoarded",
          },
        },
        
        {
          path: "/:organizationSlug/contact",
          name: "editor-contact-org",
          component: () => import("./views/editor/Contact.vue"),
          meta: {
            rule: "editor",
            title: "Contact | Editor | GetBoarded",
          },
        },
        {
          path: "/:boardSlug/:boardUserId/career-history",
          name: "editor-career-history-custom",
          component: () => import("./views/editor/CareerHistory.vue"),
          meta: {
            rule: "editor",
            title: "Career History | Editor | GetBoarded",
          },
        },
        {
          path: "/career-history",
          name: "editor-career-history",
          component: () => import("./views/editor/CareerHistory.vue"),
          meta: {
            rule: "editor",
            title: "Career History | Editor | GetBoarded",
          },
        },
        {
          path: "/:organizationSlug/career-history",
          name: "editor-career-history-org",
          component: () => import("./views/editor/CareerHistory.vue"),
          meta: {
            rule: "editor",
            title: "Career History | Editor | GetBoarded",
          },
        },
        {
          path: "/:boardSlug/:boardUserId/educational-qualifications",
          name: "editor-educational-qualifications-custom",
          component: () =>
            import("./views/editor/EducationalQualifications.vue"),
          meta: {
            rule: "editor",
            title: "Educational Qualifications | Editor | GetBoarded",
          },
        },
        {
          path: "/educational-qualifications",
          name: "editor-educational-qualifications",
          component: () =>
            import("./views/editor/EducationalQualifications.vue"),
          meta: {
            rule: "editor",
            title: "Educational Qualifications | Editor | GetBoarded",
          },
        },
        {
          path: "/:organizationSlug/educational-qualifications",
          name: "editor-educational-qualifications-org",
          component: () =>
            import("./views/editor/EducationalQualifications.vue"),
          meta: {
            rule: "editor",
            title: "Educational Qualifications | Editor | GetBoarded",
          },
        },
        {
          path: "/:boardSlug/:boardUserId/skills",
          name: "editor-skills-custom",
          component: () => import("./views/editor/Skills.vue"),
          meta: {
            rule: "editor",
            title: "Skills | Editor | GetBoarded",
          },
        },
        {
          path: "/skills",
          name: "editor-skills",
          component: () => import("./views/editor/Skills.vue"),
          meta: {
            rule: "editor",
            title: "Skills | Editor | GetBoarded",
          },
        },
        {
          path: "/:organizationSlug/skills",
          name: "editor-skills-org",
          component: () => import("./views/editor/Skills.vue"),
          meta: {
            rule: "editor",
            title: "Skills | Editor | GetBoarded",
          },
        },
        {
          path: "/:boardSlug/:boardUserId/personality",
          name: "editor-personality-custom",
          component: () => import("./views/editor/personality/Main.vue"),
          meta: {
            rule: "editor",
            title: "Personality | Editor | GetBoarded",
          },
        },
        {
          path: "/personality",
          name: "editor-personality",
          component: () => import("./views/editor/personality/Main.vue"),
          meta: {
            rule: "editor",
            title: "Personality | Editor | GetBoarded",
          },
        },
        {
          path: "/:organizationSlug/personality",
          name: "editor-abilities-org",
          component: () => import("./views/editor/personality/Main.vue"),
          meta: {
            rule: "editor",
            title: "Personality | Editor | GetBoarded",
          },
        },
        {
          path: "/:boardSlug/:boardUserId/projects",
          name: "editor-projects-custom",
          component: () => import("./views/editor/Projects.vue"),
          meta: {
            rule: "editor",
            title: "Projects | Editor | GetBoarded",
          },
        },
        {
          path: "/projects",
          name: "editor-projects",
          component: () => import("./views/editor/Projects.vue"),
          meta: {
            rule: "editor",
            title: "Projects | Editor | GetBoarded",
          },
        },
        {
          path: "/:organizationSlug/projects",
          name: "editor-projects-org",
          component: () => import("./views/editor/Projects.vue"),
          meta: {
            rule: "editor",
            title: "Projects | Editor | GetBoarded",
          },
        },

        {
          path: "/:boardSlug/:boardUserId/offers",
          name: "editor-offers-custom",
          component: () => import("./views/editor/Offers.vue"),
          meta: {
            rule: "editor",
            title: "Offers | Editor | GetBoarded",
          },
        },
        {
          path: "/offers",
          name: "editor-offers",
          component: () => import("./views/editor/Offers.vue"),
          meta: {
            rule: "editor",
            title: "Offers | Editor | GetBoarded",
          },
        },
        {
          path: "/:organizationSlug/offers",
          name: "editor-offers-org",
          component: () => import("./views/editor/Offers.vue"),
          meta: {
            rule: "editor",
            title: "Offers | Editor | GetBoarded",
          },
        },
        
        // In any other case, redirect to editor about page
        {
          path: "/:boardSlug/:boardUserId/*",
          redirect: "/:boardSlug/:boardUserId/about",
        },
        {
          path: "/",
          redirect: "/about",
        },
        /*{
            path: '/:organizationSlug/editor/credentials',
            name: 'editor-credentials',
            component: () => import('./views/editor/Credentials.vue'),
            meta: {
              rule: 'editor',
              title: 'Credentials | Editor | GetBoarded'
            }
          },
          {
            path: '/:organizationSlug/editor/widgets',
            name: 'editor-widgets',
            component: () => import('./views/editor/Widgets.vue'),
            meta: {
              rule: 'editor',
              title: 'Widgets | Editor | GetBoarded'
            }
          },
          {
            path: '/:organizationSlug/editor/videos',
            name: 'editor-videos',
            component: () => import('./views/editor/Videos.vue'),
            meta: {
              rule: 'editor',
              title: 'Videos | Editor | GetBoarded'
            }
          },
          {
            path: '/:organizationSlug/editor/additional-information',
            name: 'editor-additional-information',
            component: () => import('./views/editor/AdditionalInformation.vue'),
            meta: {
              rule: 'editor',
              title: 'Additional Information | Editor | GetBoarded'
            }
          },*/
      ],
    },
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPageResume.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/profile/:userSlug",
          name: "published-resume",
          meta: {
            title: "Talent Card | GetBoarded",
          },
        },
        {
          path: ":organizationSlug/profile/:userSlug",
          name: "published-resume-custom",
          meta: {
            title: "Talent Card | GetBoarded",
          },
        },
        {
          path: ":boardSlug/:boardUserId/profile/:userSlug",
          name: "published-resume-custom",
          meta: {
            title: "Talent Card | GetBoarded",
          },
        },
      ],
    }
  ],
});

router.beforeEach((to, from, next) => {

  // Set Page Title
  const DEFAULT_TITLE = "GetBoarded";
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });

  // // console.log(store.state.auth);
  const isAuthenticated = store.state.auth.isUserLoggedIn;
  // // console.log(isAuthenticated, to.meta.authenticationRequired);
  if (to.meta.authenticationRequired && !isAuthenticated) {
    window.location.href = `${constants.apiHost}/oauth`; // "/login";
  } else {
    return next();
  }
});

router.afterEach((to, from) => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
  // const DEFAULT_TITLE = 'GetBoarded'
  // Vue.nextTick(() => {
  //     document.title = to.meta.title || DEFAULT_TITLE;
  // });
});

export default router;
